import { RouteObject } from 'react-router-dom';
import AzureProvider from 'src/azure/context';

import AutomationRulePage from 'src/pages/automation-rule';
import HomePage from 'src/pages/home';

import App from 'src/pages/app';

export const privateRoutes: RouteObject[] = [
	{
		path: '/',
		element: (
			<AzureProvider>
				<App />
			</AzureProvider>
		),
		children: [
			{
				path: '/',
				element: <HomePage />
			},
			{
				path: '/automation-rule',
				element: <AutomationRulePage />
			},
		]
	}];